/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { createBelegeRouterDefinitions } from "../../Belege/Routes/belegeRouterDefintions";
import { createArtikelanzeigenRouterDefinitions } from "../../Einstellungen/Routes/einstellungenRouterDefintions";
import { createBelegungenRouterDefinitions } from "../../Ressourcen/Routes/ressourcenRouterDefintions";
import { createBestellpositionRouterDefinitions, createBestellterArtikelRouterDefinitions, createBestellungenRouterDefinitions, createTeilnahmenRouterDefinitions } from "../../Teilnahmen/Routes/teilnahmenRouterDefintions";
import ArtikelEMailEinstellungenBreadcrumb from "../Components/ArtikelEMailEinstellungenBreadcrumb";
import ArtikelEMailEinstellungenView from "../Views/ArtikelEMailEinstellungenView";
import AppRouterDefinition from "./../../../AppRouterDefinition";
import VerticalSplit from "./../../../Basis/Components/VerticalSplit";

const DozierendBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/DozierendBreadcrumb"));
const DozierenddateiBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/DozierenddateiBreadcrumb"));
const DozierenddateiDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/DozierenddateiDetailsView"));
const DozierenddateienBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/DozierenddateienBreadcrumb"));
const DozierenddateienNavigationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/DozierenddateienNavigationView"));
const DozierenddateienView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/DozierenddateienView"));
const DozierenddateiView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/DozierenddateiView"));
const DozierendDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/DozierendDetailsView"));
const DozierendeBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/DozierendeBreadcrumb"));
const DozierendeNavigationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/DozierendeNavigationView"));
const DozierendeView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/DozierendeView"));
const DozierendtexteBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/DozierendtexteBreadcrumb"));
const DozierendSeminareBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/DozierendSeminareBreadcrumb"));
const DozierendtexteView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/DozierendtexteView"));
const DozierendView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/DozierendView"));
const DozierendbilderView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/DozierendbilderView"));
const DozierendbilderBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/DozierendbilderBreadcrumb"));
const DozierendbildView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/DozierendbildView"));
const DozierendbildDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/DozierendbildDetailsView"));
const DozierendbildBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/DozierendbildBreadcrumb"));
const DozierendbilderNavigationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/DozierendbilderNavigationView"));
const FrageboegenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/FrageboegenBreadcrumb"));
const FrageboegenNavigationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/FrageboegenNavigationView"));
const FrageboegenView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/FrageboegenView"));
const FragebogenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/FragebogenBreadcrumb"));
const FragebogenDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/FragebogenDetailsView"));
const FragebogenFrageBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/FragebogenFrageBreadcrumb"));
const FragebogenFrageDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/FragebogenFrageDetailsView"));
const FragebogenFragenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/FragebogenFragenBreadcrumb"));
const FragebogenFragenNavigationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/FragebogenFragenNavigationView"));
const FragebogenFragenView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/FragebogenFragenView"));
const FragebogenFrageView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/FragebogenFrageView"));
const FragebogenView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/FragebogenView"));
const SeminarevaluationBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminarevaluationBreadcrumb"))
const SeminarevaluationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarevaluationView"))
const KategorieBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/KategorieBreadcrumb"));
const KategorieDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminareKategorieDetailsView"));
const KategorienBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/KategorienBreadcrumb"));
const KategorienNavigationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminareKategorienNavigationView"));
const KategorienView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminareKategorienView"));
const KategorieView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminareKategorieView"));
const SeminarAnwesenheitslisteBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"./../Components/SeminarAnwesenheitslisteBreadcrumb"));
const SeminarAnwesenheitslisteView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarAnwesenheitslisteView"));
const SeminarTicketBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"./../Components/SeminarTicketBreadcrumb"));
const SeminarTicketView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarTicketView"));
const SeminarBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminarBreadcrumb"));
const SeminardateiBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminardateiBreadcrumb"));
const SeminardateiDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminardateiDetailsView"));
const SeminardateienBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminardateienBreadcrumb"));
const SeminardateienNavigationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminardateienNavigationView"));
const SeminardateienView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminardateienView"));
const SeminardateiView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminardateiView"));
const SeminarDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarDetailsView"));
const SeminarDozierendBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminarDozierendBreadcrumb"));
const SeminarDozierendDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarDozierendDetailsView"));
const SeminarDozierendeBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminarDozierendeBreadcrumb"));
const SeminarDozierendeNavigationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarDozierendeNavigationView"));
const SeminarDozierendeView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarDozierendeView"));
const SeminarDozierendView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarDozierendView"));
const SeminareBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminareBreadcrumb"));
const SeminareNavigationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminareNavigationView"));
const SeminarEMailEinstellungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminarEMailEinstellungenBreadcrumb"));
const SeminarEMailEinstellungenView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarEMailEinstellungenView"));
const SeminareView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminareView"));
const PreisBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/PreisBreadcrumb"));
const PreisDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/PreisDetailsView"));
const PreiseBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/PreiseBreadcrumb"));
const PreiseNavigationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/PreiseNavigationView"));
const PreiseView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/PreiseView"));
const PreispositionBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/PreispositionBreadcrumb"));
const PreispositionDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/PreispositionDetailsView"))
const PreispositionenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/PreispositionenBreadcrumb"));
const PreispositionenNavigationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/PreispositionenNavigationView"))
const PreispositionenView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/PreispositionenView"));
const PreispositionView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/PreispositionView"));
const PreisView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/PreisView"));
const SeminarBelegungenView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarBelegungenView"));
const SeminarTeamsEinstellungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"./../Components/SeminarTeamsEinstellungenBreadcrumb"));
const SeminarTeamsEinstellungenView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"./../Views/SeminarTeamsEinstellungenView"));
const SeminartermineBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminartermineBreadcrumb"));
const SeminarSeminarreihenZuSeminarBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminarreihenZuSeminarBreadcrumb"));
const SeminartexteBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminartexteBreadcrumb"));
const SeminartexteView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminartexteView"));
const SeminarZusatzfelderView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarZusatzfelderView"));
const SeminarZusatzfelderBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminarZusatzfelderBreadcrumb"));
const SeminarView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarView"));
const SeminarZoomEinstellungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"./../Components/SeminarZoomEinstellungenBreadcrumb"));
const SeminarZoomEinstellungenView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"./../Views/SeminarZoomEinstellungenView"));
const TerminBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/TerminBreadcrumb"));
const TerminDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/TerminDetailsView"));
const TermineNavigationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/TermineNavigationView"));
const TermineView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/TermineView"));
const TermintexteBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/TermintexteBreadcrumb"));
const TermintexteView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/TermintexteView"));
const TerminView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/TerminView"));
const RabattcodesView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../../Teilnahmen/Views/RabattcodesView"));
const RabattcodeDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../../Teilnahmen/Views/RabattcodeDetailsView"));
const RabattcodesNavigationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../../Teilnahmen/Views/RabattcodesNavigationView"));
const RabattcodeView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../../Teilnahmen/Views/RabattcodeView"));
const RabattcodesBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../../Teilnahmen/Components/RabattcodesBreadcrumb"));
const RabattcodeBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../../Teilnahmen/Components/RabattcodeBreadcrumb"));
const RabattcodeEinloesungenView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../../Teilnahmen/Views/RabattcodeEinloesungenView"));
const RabattcodeEinloesungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../../Teilnahmen/Components/RabattcodeEinloesungenBreadcrumb"));
const SeminarbildBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminarbildBreadcrumb"));
const SeminarbildDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarbildDetailsView"));
const SeminarbilderBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminarbilderBreadcrumb"));
const SeminarbilderNavigationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarbilderNavigationView"));
const SeminarbilderView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarbilderView"));
const SeminarbildView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarbildView"));
const SeminarSeminarreihenView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarSeminarreihenView"));
const SeminarreihenView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarreihenView"));
const SeminarreiheView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarreiheView"));
const SeminarreihenNavigationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarreihenNavigationView"));
const SeminarreiheDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarreiheDetailsView"));
const SeminarreihenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminarreihenBreadcrumb"));
const SeminarreiheBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminarreiheBreadcrumb"));
const SeminarreihetexteView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarreihetexteView"));
const SeminarreihetexteBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminarreihetexteBreadcrumb"));
const SeminarreiheSeminareView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarreiheSeminareView"));
const SeminarreiheSeminareBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminarreiheSeminareBreadcrumb"));
const WartelisteView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../../Teilnahmen/Views/WartelisteView"));
const WartelisteBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../../Teilnahmen/Components/WartelisteBreadcrumb"));
const KooperationspartnerView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/KooperationspartnerView"));
const KooperationspartnerBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/KooperationspartnerBreadcrumb"));
const KooperationspartnerTabsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/KooperationspartnerTabsView"));
const KooperationspartnerDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/KooperationspartnerDetailsView"));
const KooperationspartnerNavigationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/KooperationspartnerNavigationView"));
const SeminarKooperationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarKooperationView"));
const KooperationspartnerDetailsBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/KooperationspartnerDetailsBreadcrumb"));
const SeminarKooperationBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */ "../Components/SeminarKooperationBreadcrumb"));
const SeminarreiheSeminarView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarreiheSeminarView"));
const SeminarreiheSeminareNavigationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarreiheSeminareNavigationView"));
const SeminarreiheSeminarDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarreiheSeminarDetailsView"));
const SeminarreiheSeminarBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminarreiheSeminarBreadcrumb"));
const SeminarreihebilderView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarreihebilderView"));
const SeminarreihebilderBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminarreihebilderBreadcrumb"));
const SeminarreihebilderNavigationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarreihebilderNavigationView"));
const SeminarreihebildView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarreihebildView"));
const SeminarreihebildDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarreihebildDetailsView"));
const SeminarreihebildBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminarreihebildBreadcrumb"));
const SeminarreihedateienView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarreihedateienView"));
const SeminarreihedateienBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminarreihedateienBreadcrumb"));
const SeminarreihedateienNavigationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarreihedateienNavigationView"));
const SeminarreihedateiView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarreihedateiView"));
const SeminarreihedateiDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarreihedateiDetailsView"));
const SeminarreihedateiBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminarreihedateiBreadcrumb"));
const ArtikelBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/ArtikelBreadcrumb"));
const ArtikelDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/ArtikelDetailsView"));
const ArtikelsammlungBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/ArtikelsammlungBreadcrumb"));
const ArtikelsammlungNavigationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/ArtikelsammlungNavigationView"));
const ArtikelsammlungView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/ArtikelsammlungView"));
const ArtikeltexteBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/ArtikeltexteBreadcrumb"));
const ArtikeltexteView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/ArtikeltexteView"));
const ArtikelView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/ArtikelView"));
const ArtikelbilderView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/ArtikelbilderView"));
const ArtikelbilderBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/ArtikelbilderBreadcrumb"));
const ArtikelbilderNavigationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/ArtikelbilderNavigationView"));
const ArtikelbildView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/ArtikelbildView"));
const ArtikelbildDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/ArtikelbildDetailsView"));
const ArtikelbildBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/ArtikelbildBreadcrumb"));
const ArtikeldateienView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/ArtikeldateienView"));
const ArtikeldateienBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/ArtikeldateienBreadcrumb"));
const ArtikeldateienNavigationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/ArtikeldateienNavigationView"));
const ArtikeldateiView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/ArtikeldateiView"));
const ArtikeldateiDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/ArtikeldateiDetailsView"));
const ArtikeldateiBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/ArtikeldateiBreadcrumb"));
const ArtikelzuordnungenView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/ArtikelzuordnungenView"));
const ArtikelzuordnungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/ArtikelzuordnungenBreadcrumb"));
const PaketpreiseView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/PaketpreiseView"));
const PaketpreiseBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/PaketpreiseBreadcrumb"));
const PaketpreiseNavigationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/PaketpreiseNavigationView"));
const PaketpreisView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/PaketpreisView"));
const PaketpreisDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/PaketpreisDetailsView"));
const PaketpreisBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/PaketpreisBreadcrumb"));
const StornobedingungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/StornobedingungenBreadcrumb"));
const StornobedingungDefinitionZuteilungView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../../Belege/Views/StornobedingungDefinitionZuteilungView"));
const TeilnahmenView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"./../../Teilnahmen/Views/TeilnahmenView"));
const TeilnahmenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */ "./../../Teilnahmen/Components/TeilnahmenBreadcrumb"));
const SeminarGrundeinstellungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminarGrundeinstellungenBreadcrumb"));
const SeminarGrundeinstellungenEMailBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminarGrundeinstellungenEMailBreadcrumb"));
const SeminarGrundeinstellungenView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarGrundeinstellungenView"));
const SeminarGrundeinstellungenDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarGrundeinstellungenDetailsView"));
const SeminarGrundeinstellungenEMailView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarGrundeinstellungenEMailView"));
const SeminarGrundeinstellungenTicketBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminarGrundeinstellungenTicketBreadcrumb"));
const SeminarGrundeinstellungenTicketView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarGrundeinstellungenTicketView"));
const ArtikelGrundeinstellungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/ArtikelGrundeinstellungenBreadcrumb"));
const ArtikelGrundeinstellungenView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/ArtikelGrundeinstellungenView"));
const ArtikelGrundeinstellungenDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/ArtikelGrundeinstellungenDetailsView"));
const RegellisteView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/RegellisteView"));
const RegellisteNavigationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/RegellisteNavigationView"));
const RegelView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/RegelView"));
const RegelDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/RegelDetailsView"));
const RegellisteBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/RegellisteBreadcrumb/"));
const RegelBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/RegelBreadcrumb"));
const SeminarVerpflegungsartenView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarVerpflegungsartenView"));
const SeminarverpflegungBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminarverpflegungBreadcrumb"));
const SeminarRechnungsdatenView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarRechnungsdatenView"));
const SeminarRechnungsdatenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminarRechnungsdatenBreadcrumb"));
const SeminarGruppeView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarGruppeView"));
const SeminarGruppeBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminarGruppeBreadcrumb"));
const SeminarreiheZusatzfelderView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarreiheZusatzfelderView"));
const SeminarreiheZusatzfelderBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminarreiheZusatzfelderBreadcrumb"));
const GebuchteVerpflegungenView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/GebuchteVerpflegungen"));
const SeminarVeranstaltungsortView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/SeminarVeranstaltungsortView"));
const SeminarVeranstaltungsortBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/SeminarVeranstaltungsortBreadcrumb"));
const DozierendZusatzfelderView = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Views/DozierendZusatzfelderView"));
const DozierendZusatzfelderBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Seminare" */"../Components/DozierendZusatzfelderBreadcrumb"));

// Dokumente-Teil der Seminare
const SeminarZertifikateView = React.lazy(() => import(/* webpackChunkName: "Seminare_Dokumente" */"../../Dokumente/Views/SeminarZertifikateView"));
const SeminarZertifikateNavigationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Dokumente" */"../../Dokumente/Views/SeminarZertifikateNavigationView"));
const SeminarZertifikatView = React.lazy(() => import(/* webpackChunkName: "Seminare_Dokumente" */"../../Dokumente/Views/SeminarZertifikatView"));
const SeminarZertifikatTeilnahmenView = React.lazy(() => import(/* webpackChunkName: "Seminare_Dokumente" */"../../Dokumente/Views/SeminarZertifikatTeilnahmenView"));
const SeminarZertifikatDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Dokumente" */"../../Dokumente/Views/SeminarZertifikatDetailsView"));
const SeminarZertifikateBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Dokumente" */"../../Dokumente/Components/SeminarZertifikateBreadcrumb"));
const SeminarZertifikatBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Dokumente" */"../../Dokumente/Components/SeminarZertifikatBreadcrumb"));
const SeminarZertifikatTeilnahmenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Dokumente" */"../../Dokumente/Components/SeminarZertifikatTeilnahmenBreadcrumb"));
const SeminarDozierendZertifikatBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Dokumente" */"./../../Dokumente/Components/SeminarDozierendZertifikatBreadcrumb"));
const SeminarDozierendZertifikateBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Seminare_Dokumente" */"./../../Dokumente/Components/SeminarDozierendZertifikateBreadcrumb"));
const SeminarDozierendZertifikateView = React.lazy(() => import(/* webpackChunkName: "Seminare_Dokumente" */"./../../Dokumente/Views/SeminarDozierendZertifikateView"));
const SeminarDozierendZertifikateNavigationView = React.lazy(() => import(/* webpackChunkName: "Seminare_Dokumente" */"./../../Dokumente/Views/SeminarDozierendZertifikateNavigationView"));
const SeminarDozierendZertifikatView = React.lazy(() => import(/* webpackChunkName: "Seminare_Dokumente" */"./../../Dokumente/Views/SeminarDozierendZertifikatView"));
const SeminarDozierendZertifikatDetailsView = React.lazy(() => import(/* webpackChunkName: "Seminare_Dokumente" */"./../../Dokumente/Views/SeminarDozierendZertifikatDetailsView"));
const SeminarDozierendZertifikatViewRedirect = React.lazy(() => import(/* webpackChunkName: "Seminare_Dokumente" */"./../../Dokumente/Views/SeminarDozierendZertifikatViewRedirect"));

// Ressourcen-Teil der Seminare
const BelegungBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../../Ressourcen/Components/BelegungBreadcrumb"));
const BelegungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../../Ressourcen/Components/BelegungenBreadcrumb"));
const BelegungDetailsView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../../Ressourcen/Views/BelegungDetailsView"));
const BelegungenNavigationView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../../Ressourcen/Views/BelegungenNavigationView"));
const BelegungView = React.lazy(() => import(/* webpackChunkName: "Ressourcen_Ressourcen" */"../../Ressourcen/Views/BelegungView"));

const PREISPATH = "/preis/:preisId";
const TERMINPATH = "/seminar/:seminarId/termin/:terminId";
const SEMINARDOZIERENDPATH = "/seminar/:seminarId/dozierend/:seminarDozierendId";
const SEMINARPATH = "/seminar/:seminarId";
const KATEGORIEPATH = "/kategorie/:kategorieId";
const DOZIERENDEPATH = "/dozierende";
const DOZIERENDPATH = "/dozierend/:dozierendId";
const DOZIERENDDATEIENPATH = `${DOZIERENDPATH}/dateien`;
const DOZIERENDDATEIPATH = `${DOZIERENDPATH}/datei/:dozierenddateiId`;
const DOZIERENDBILDPATH = `${DOZIERENDPATH}/bild/:dozierendbildId`;
const ARTIKELSAMMLUNGPATH = "/artikelsammlung";
const ARTIKELPATH = "/artikel/:artikelId";
const ARTIKELBILDPATH = "/artikel/:artikelId/bild/:artikelbildId";
const ARTIKELDATEIPATH = "/artikel/:artikelId/datei/:artikeldateiId";
const TERMINBELEGUNGPATH = "/seminar/:seminarId/termin/:terminId/belegung/:belegungId";
const SEMINARBELEGUNGPATH = "/seminar/:seminarId/belegung/:belegungId";
const PREISPOSITIONPATH = `${PREISPATH}/position/:preispositionId`;
const SEMINARREIHEPATH = "/seminarreihe/:seminarreiheId";
const KOOPERATIONSPARTNERPATH = "/kooperationspartner";
const SEMINARREIHESEMINARPATH = `${SEMINARREIHEPATH}/seminar/:seminarreiheSeminarId`;
const SEMINARREIHEBILDPATH = `${SEMINARREIHEPATH}/bild/:seminarreihebildId`;
const SEMINARREIHEDATEIPATH = `${SEMINARREIHEPATH}/datei/:seminarreihedateiId`;
const PAKETPREISPATH = `${SEMINARREIHEPATH}/paketpreis/:paketpreisId`;
const SEMINAREINSTELLUNGENPATH = `/seminareinstellungen`;
const ARTIKELEINSTELLUNGENPATH = `/artikeleinstellungen`;

export function createArtikelRouterDefinitions(
    pathPrefix: string | undefined,
    createPreBreadcrumbs: (createProps: any) => Array<JSX.Element>): Array<AppRouterDefinition> {
    let safePathPrefix = pathPrefix ?? "";

    return [
        {
            exact: pathPrefix ? true : undefined,
            parentPath: pathPrefix ? safePathPrefix : undefined,
            path: safePathPrefix + ARTIKELSAMMLUNGPATH,
            render: (props) => <ArtikelsammlungView {...props} />,
            createBreadcrumbs: (props) => [
                ...createPreBreadcrumbs(props),
                <ArtikelsammlungBreadcrumb seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />]
        },
        {
            path: safePathPrefix + ARTIKELPATH,
            render: (props) => <VerticalSplit
                left={() => <ArtikelsammlungNavigationView {...props} />}
                right={() => <ArtikelView {...props} />}
            />,
            createBreadcrumbs: (props) => [
                ...createPreBreadcrumbs(props),
                <ArtikelsammlungBreadcrumb seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
                <ArtikelBreadcrumb {...props} artikelId={props.artikelId} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />]
        },
        {
            exact: true,
            parentPath: safePathPrefix + ARTIKELPATH,
            path: safePathPrefix + ARTIKELPATH,
            render: (props) => <ArtikelDetailsView {...props} />,
            createBreadcrumbs: (props) => [
                ...createPreBreadcrumbs(props),
                <ArtikelsammlungBreadcrumb seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
                <ArtikelBreadcrumb {...props} artikelId={props.artikelId} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />],
        },
        {
            exact: true,
            path: safePathPrefix + `${ARTIKELPATH}/stornobedingungen`,
            parentPath: safePathPrefix + ARTIKELPATH,
            render: (renderProps: any) => <StornobedingungDefinitionZuteilungView {...renderProps} />,
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <ArtikelsammlungBreadcrumb seminarId={createProps.seminarId} seminarreiheId={createProps.seminarreiheId} />,
                <ArtikelBreadcrumb {...createProps} artikelId={createProps.artikelId} seminarId={createProps.seminarId} seminarreiheId={createProps.seminarreiheId} />,
                <StornobedingungenBreadcrumb {...createProps} artikelId={createProps.artikelId} seminarreiheId={createProps.seminarreiheId} />
            ],
        },
        {
            exact: true,
            parentPath: safePathPrefix + ARTIKELPATH,
            path: safePathPrefix + `${ARTIKELPATH}/texte`,
            render: (props) => <ArtikeltexteView {...props} />,
            createBreadcrumbs: (props) => [
                ...createPreBreadcrumbs(props),
                <ArtikelsammlungBreadcrumb seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
                <ArtikelBreadcrumb {...props} artikelId={props.artikelId} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
                <ArtikeltexteBreadcrumb {...props} artikelId={props.artikelId} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />],
        },
        {
            exact: true,
            parentPath: safePathPrefix + ARTIKELPATH,
            path: safePathPrefix + `${ARTIKELPATH}/eMailEinstellungen`,
            render: (props) => <ArtikelEMailEinstellungenView {...props} />,
            createBreadcrumbs: (props) => [
                ...createPreBreadcrumbs(props),
                <ArtikelsammlungBreadcrumb seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
                <ArtikelBreadcrumb {...props} artikelId={props.artikelId} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
                <ArtikelEMailEinstellungenBreadcrumb {...props} artikelId={props.artikelId} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />],
        },
        {
            parentPath: safePathPrefix + ARTIKELPATH,
            path: safePathPrefix + `${ARTIKELPATH}/bilder`,
            render: props => <ArtikelbilderView {...props} />,
            createBreadcrumbs: props => [
                ...createPreBreadcrumbs(props),
                <ArtikelsammlungBreadcrumb {...props} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
                <ArtikelBreadcrumb {...props} artikelId={props.artikelId} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
                <ArtikelbilderBreadcrumb {...props} artikelId={props.artikelId} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
            ],
        },
        {
            path: safePathPrefix + ARTIKELBILDPATH,
            render: props => (
                <VerticalSplit
                    left={() => <ArtikelbilderNavigationView {...props} />}
                    right={() => <ArtikelbildView {...props} />}
                />
            ),
            createBreadcrumbs: props => [
                ...createPreBreadcrumbs(props),
                <ArtikelsammlungBreadcrumb {...props} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
                <ArtikelBreadcrumb {...props} artikelId={props.artikelId} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
                <ArtikelbilderBreadcrumb {...props} artikelId={props.artikelId} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
                <ArtikelbildBreadcrumb {...props} artikelId={props.artikelId} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
            ],
        },
        {
            exact: true,
            parentPath: safePathPrefix + ARTIKELBILDPATH,
            path: safePathPrefix + ARTIKELBILDPATH,
            render: props => <ArtikelbildDetailsView {...props} />,
            createBreadcrumbs: props => [
                ...createPreBreadcrumbs(props),
                <ArtikelsammlungBreadcrumb {...props} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
                <ArtikelBreadcrumb {...props} artikelId={props.artikelId} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
                <ArtikelbilderBreadcrumb {...props} artikelId={props.artikelId} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
                <ArtikelbildBreadcrumb {...props} artikelId={props.artikelId} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
            ],
        },
        {
            parentPath: safePathPrefix + ARTIKELPATH,
            path: safePathPrefix + `${ARTIKELPATH}/dateien`,
            render: props => <ArtikeldateienView {...props} />,
            createBreadcrumbs: props => [
                ...createPreBreadcrumbs(props),
                <ArtikelsammlungBreadcrumb {...props} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
                <ArtikelBreadcrumb {...props} artikelId={props.artikelId} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
                <ArtikeldateienBreadcrumb {...props} artikelId={props.artikelId} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
            ],
        },
        {
            path: safePathPrefix + ARTIKELDATEIPATH,
            render: props => (
                <VerticalSplit
                    left={() => <ArtikeldateienNavigationView {...props} />}
                    right={() => <ArtikeldateiView {...props} />}
                />
            ),
            createBreadcrumbs: props => [
                ...createPreBreadcrumbs(props),
                <ArtikelsammlungBreadcrumb {...props} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
                <ArtikelBreadcrumb {...props} artikelId={props.artikelId} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
                <ArtikeldateienBreadcrumb {...props} artikelId={props.artikelId} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
                <ArtikeldateiBreadcrumb {...props} artikelId={props.artikelId} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
            ],
        },
        {
            exact: true,
            parentPath: safePathPrefix + ARTIKELDATEIPATH,
            path: safePathPrefix + ARTIKELDATEIPATH,
            render: props => <ArtikeldateiDetailsView {...props} />,
            createBreadcrumbs: props => [
                ...createPreBreadcrumbs(props),
                <ArtikelsammlungBreadcrumb {...props} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
                <ArtikelBreadcrumb {...props} artikelId={props.artikelId} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
                <ArtikeldateienBreadcrumb {...props} artikelId={props.artikelId} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
                <ArtikeldateiBreadcrumb {...props} artikelId={props.artikelId} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
            ],
        },
        {
            parentPath: safePathPrefix + ARTIKELPATH,
            path: safePathPrefix + `${ARTIKELPATH}/zuordnungen`,
            render: props => <ArtikelzuordnungenView {...props} />,
            createBreadcrumbs: props => [
                ...createPreBreadcrumbs(props),
                <ArtikelsammlungBreadcrumb {...props}/>,
                <ArtikelBreadcrumb {...props} />,
                <ArtikelzuordnungenBreadcrumb {...props} />,
            ],
        },
        ...createPreiseRouterDefinitions(
            safePathPrefix + ARTIKELPATH,
            (props) => [
                ...createPreBreadcrumbs(props),
                <ArtikelsammlungBreadcrumb {...props} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
                <ArtikelBreadcrumb {...props} artikelId={props.artikelId} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />],
        ),
        ...createRabattcodesRouterDefinitions(
            safePathPrefix + ARTIKELPATH,
            (props) => [
                ...createPreBreadcrumbs(props),
                <ArtikelsammlungBreadcrumb {...props} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />,
                <ArtikelBreadcrumb {...props} artikelId={props.artikelId} seminarId={props.seminarId} seminarreiheId={props.seminarreiheId} />],
        ),
        ...createArtikelanzeigenRouterDefinitions(
            safePathPrefix,
            (props) => [
                ...createPreBreadcrumbs(props),
                <ArtikelsammlungBreadcrumb {...props} />,
                <ArtikelBreadcrumb {...props} />],
        ),
    ]
}

export function createRabattcodesRouterDefinitions(
    pathPrefix: string | undefined,
    createPreBreadcrumbs: (createProps: any) => Array<JSX.Element>): Array<AppRouterDefinition> {
    let safePathPrefix = pathPrefix ?? "";

    return [
        {
            exact: true,
            parentPath: safePathPrefix,
            path: safePathPrefix + "/rabattcodes",
            render: props => <RabattcodesView {...props} />,
            createBreadcrumbs: props => [
                ...createPreBreadcrumbs(props),
                <RabattcodesBreadcrumb {...props} seminarId={props.seminarId} artikelId={props.artikelId} adresseId={props.adresseId} seminarreiheId={props.seminarreiheId} />,
            ],
        },
        {
            path: safePathPrefix + "/rabattcode/:rabattcodeId",
            render: props => <VerticalSplit
                right={() => <RabattcodeView {...props} />}
                left={() => <RabattcodesNavigationView {...props} />}
            />,
            createBreadcrumbs: props => [
                ...createPreBreadcrumbs(props),
                <RabattcodesBreadcrumb {...props} seminarId={props.seminarId} artikelId={props.artikelId} adresseId={props.adresseId} seminarreiheId={props.seminarreiheId} />,
                <RabattcodeBreadcrumb {...props} seminarId={props.seminarId} artikelId={props.artikelId} adresseId={props.adresseId} seminarreiheId={props.seminarreiheId} />,
            ],
        },
        {
            exact: true,
            parentPath: safePathPrefix + "/rabattcode/:rabattcodeId",
            path: safePathPrefix + "/rabattcode/:rabattcodeId",
            render: props => <RabattcodeDetailsView {...props} />,
            createBreadcrumbs: props => [
                ...createPreBreadcrumbs(props),
                <RabattcodesBreadcrumb {...props} seminarId={props.seminarId} artikelId={props.artikelId} adresseId={props.adresseId} />,
                <RabattcodeBreadcrumb {...props} seminarId={props.seminarId} artikelId={props.artikelId} adresseId={props.adresseId} />,
            ],
        },
        {
            exact: true,
            parentPath: safePathPrefix + "/rabattcode/:rabattcodeId",
            path: safePathPrefix + "/rabattcode/:rabattcodeId/einloesungen",
            render: props => <RabattcodeEinloesungenView {...props} />,
            createBreadcrumbs: props => [
                ...createPreBreadcrumbs(props),
                <RabattcodesBreadcrumb {...props} seminarId={props.seminarId} artikelId={props.artikelId} adresseId={props.adresseId} />,
                <RabattcodeBreadcrumb {...props} seminarId={props.seminarId} artikelId={props.artikelId} adresseId={props.adresseId} />,
                <RabattcodeEinloesungenBreadcrumb {...props} seminarId={props.seminarId} artikelId={props.artikelId} adresseId={props.adresseId} />,
            ],
        },
    ];
}

export function createPreiseRouterDefinitions(
    pathPrefix: string | undefined,
    createPreBreadcrumbs: (createProps: any) => Array<JSX.Element>): Array<AppRouterDefinition> {
    let safePathPrefix = pathPrefix ?? "";

    return [
        {
            path: safePathPrefix + PREISPATH,
            render: (renderProps: any) => (
                <VerticalSplit
                    right={() => <PreisView {...renderProps} />}
                    left={() => <PreiseNavigationView {...renderProps} />}
                />
            ),
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <PreiseBreadcrumb seminarId={createProps.seminarId} artikelId={createProps.artikelId} seminarreiheId={createProps.seminarreiheId} />,
                <PreisBreadcrumb
                    seminarId={createProps.seminarId}
                    artikelId={createProps.artikelId}
                    seminarreiheId={createProps.seminarreiheId}
                    preisId={createProps.preisId}
                />,
            ],
        },
        {
            exact: true,
            path: safePathPrefix + PREISPATH,
            parentPath: safePathPrefix + PREISPATH,
            render: (renderProps: any) => <PreisDetailsView {...renderProps} />,
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <PreiseBreadcrumb seminarId={createProps.seminarId} artikelId={createProps.artikelId} seminarreiheId={createProps.seminarreiheId} />,
                <PreisBreadcrumb
                    seminarId={createProps.seminarId}
                    artikelId={createProps.artikelId}
                    seminarreiheId={createProps.seminarreiheId}
                    preisId={createProps.preisId}
                />,
            ],
        },
        {
            exact: true,
            path: safePathPrefix + `${PREISPATH}/positionen`,
            parentPath: safePathPrefix + PREISPATH,
            render: (renderProps: any) => <PreispositionenView {...renderProps} />,
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <PreiseBreadcrumb seminarId={createProps.seminarId} artikelId={createProps.artikelId} seminarreiheId={createProps.seminarreiheId} />,
                <PreisBreadcrumb
                    seminarId={createProps.seminarId}
                    artikelId={createProps.artikelId}
                    seminarreiheId={createProps.seminarreiheId}
                    preisId={createProps.preisId}
                />,
                <PreispositionenBreadcrumb
                    seminarId={createProps.seminarId}
                    artikelId={createProps.artikelId}
                    seminarreiheId={createProps.seminarreiheId}
                    preisId={createProps.preisId}
                />
            ],
        },
        {
            path: safePathPrefix + PREISPOSITIONPATH,
            render: (renderProps: any) => (
                <VerticalSplit
                    right={() => <PreispositionView {...renderProps} />}
                    left={() => <PreispositionenNavigationView {...renderProps} />}
                />
            ),
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <PreiseBreadcrumb seminarId={createProps.seminarId} artikelId={createProps.artikelId} seminarreiheId={createProps.seminarreiheId} />,
                <PreisBreadcrumb
                    seminarId={createProps.seminarId}
                    artikelId={createProps.artikelId}
                    seminarreiheId={createProps.seminarreiheId}
                    preisId={createProps.preisId}
                />,
                <PreispositionenBreadcrumb
                    seminarId={createProps.seminarId}
                    artikelId={createProps.artikelId}
                    seminarreiheId={createProps.seminarreiheId}
                    preisId={createProps.preisId}
                />,
                <PreispositionBreadcrumb
                    seminarId={createProps.seminarId}
                    artikelId={createProps.artikelId}
                    seminarreiheId={createProps.seminarreiheId}
                    preisId={createProps.preisId}
                    preispositionId={createProps.preispositionId}
                />
            ],
        },
        {
            exact: true,
            path: safePathPrefix + PREISPOSITIONPATH,
            parentPath: safePathPrefix + PREISPOSITIONPATH,
            render: (renderProps: any) => <PreispositionDetailsView {...renderProps} />,
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <PreiseBreadcrumb seminarId={createProps.seminarId} artikelId={createProps.artikelId} seminarreiheId={createProps.seminarreiheId} />,
                <PreisBreadcrumb
                    seminarId={createProps.seminarId}
                    artikelId={createProps.artikelId}
                    seminarreiheId={createProps.seminarreiheId}
                    preisId={createProps.preisId}
                />,
                <PreispositionBreadcrumb
                    seminarId={createProps.seminarId}
                    artikelId={createProps.artikelId}
                    seminarreiheId={createProps.seminarreiheId}
                    preisId={createProps.preisId}
                    preispositionId={createProps.preispositionId}
                />
            ],
        },
        {
            exact: true,
            path: safePathPrefix + "/preise",
            parentPath: safePathPrefix ?? undefined,
            render: (renderProps: any) => <PreiseView {...renderProps} />,
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <PreiseBreadcrumb seminarId={createProps.seminarId} artikelId={createProps.artikelId} />,
            ],
        },
    ]
}

export const seminareRouterDefintions: Array<AppRouterDefinition> = [
    {
        path: "/seminare",
        render: (renderProps: any) => <SeminareView {...renderProps} />,
        createBreadcrumbs: () => [<SeminareBreadcrumb />],
    },
    {
        path: "/seminarDozierendZertifikat/:seminarDozierendZertifikatId",
        render: (renderProps: any) => <SeminarDozierendZertifikatViewRedirect {...renderProps} />,
        createBreadcrumbs: () => [],
    },
    {
        path: "/kategorien",
        render: (renderProps: any) => <KategorienView {...renderProps} />,
        createBreadcrumbs: () => [<KategorienBreadcrumb />],
    },
    {
        path: KATEGORIEPATH,
        render: (renderProps: any) => <VerticalSplit
            left={() => <KategorienNavigationView {...renderProps} />}
            right={() => <KategorieView {...renderProps} />}
        />,
        createBreadcrumbs: (createProps: any) => [
            <KategorienBreadcrumb />,
            <KategorieBreadcrumb
                kategorieId={createProps.kategorieId}
            />,
        ],
    },
    {
        exact: true,
        path: KATEGORIEPATH,
        parentPath: KATEGORIEPATH,
        render: (renderProps: any) => <KategorieDetailsView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <KategorienBreadcrumb />,
            <KategorieBreadcrumb
                kategorieId={createProps.kategorieId}
            />,
        ],
    },
    ...createTeilnahmenRouterDefinitions(
        SEMINARPATH,
        (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
        ],
        (createProps: any) => ([{ context: "seminar", contextId: createProps.seminarId }])),
    {
        exact: true,
        path: SEMINARREIHEPATH + "/teilnahmen",
        parentPath: SEMINARREIHEPATH,
        render: (renderProps: any) => <TeilnahmenView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SeminarreihenBreadcrumb />,
            <SeminarreiheBreadcrumb seminarreiheId={createProps.seminarreiheId} />,
            <TeilnahmenBreadcrumb contextInfos={[{ context: "seminarreihe", contextId: createProps.seminarreiheId }]} />
        ],
    },
    {
        path: `/seminar/:seminarId/datei/:seminardateiId`,
        render: (renderProps: any) => (
            <VerticalSplit
                right={() => <SeminardateiView {...renderProps} />}
                left={() => <SeminardateienNavigationView {...renderProps} />}
            />
        ),
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
            <SeminardateienBreadcrumb seminarId={createProps.seminarId} />,
            <SeminardateiBreadcrumb
                seminarId={createProps.seminarId}
                seminardateiId={createProps.seminardateiId}
            />,
        ],
    },
    ...createBestellpositionRouterDefinitions(
        `${SEMINARPATH}/warteliste`,
        (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
            <WartelisteBreadcrumb seminarId={createProps.seminarId} />,
        ]),
    {
        exact: true,
        path: SEMINARPATH + "/warteliste",
        parentPath: SEMINARPATH,
        render: (renderProps: any) => <WartelisteView {...renderProps} />,
        createBreadcrumbs: (createProps) => [<SeminareBreadcrumb />, <SeminarBreadcrumb {...createProps} />, <WartelisteBreadcrumb {...createProps} />],
    },
    {
        exact: true,
        path: `/seminar/:seminarId/datei/:seminardateiId`,
        parentPath: `/seminar/:seminarId/datei/:seminardateiId`,
        render: (renderProps: any) => <SeminardateiDetailsView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
            <SeminardateienBreadcrumb seminarId={createProps.seminarId} />,
            <SeminardateiBreadcrumb
                seminarId={createProps.seminarId}
                seminardateiId={createProps.seminardateiId}
            />,
        ],
    },
    {
        path: `/seminar/:seminarId/bild/:seminarbildId`,
        render: (renderProps: any) => (
            <VerticalSplit
                right={() => <SeminarbildView {...renderProps} />}
                left={() => <SeminarbilderNavigationView {...renderProps} />}
            />
        ),
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
            <SeminarbilderBreadcrumb seminarId={createProps.seminarId} />,
            <SeminarbildBreadcrumb
                seminarId={createProps.seminarId}
                seminarbildId={createProps.seminarbildId}
            />,
        ],
    },
    {
        exact: true,
        path: `/seminar/:seminarId/bild/:seminarbildId`,
        parentPath: `/seminar/:seminarId/bild/:seminarbildId`,
        render: (renderProps: any) => <SeminarbildDetailsView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
            <SeminarbilderBreadcrumb seminarId={createProps.seminarId} />,
            <SeminarbildBreadcrumb
                seminarId={createProps.seminarId}
                seminarbildId={createProps.seminarbildId}
            />,
        ],
    },
    {
        path: TERMINPATH,
        render: (renderProps: any) => (
            <VerticalSplit
                right={() => <TerminView {...renderProps} />}
                left={() => <TermineNavigationView {...renderProps} />}
            />
        ),
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
            <SeminartermineBreadcrumb seminarId={createProps.seminarId} />,
            <TerminBreadcrumb
                seminarId={createProps.seminarId}
                terminId={createProps.terminId}
            />,
        ],
    },
    {
        exact: true,
        path: `${TERMINPATH}/texte`,
        parentPath: TERMINPATH,
        render: (renderProps: any) => <TermintexteView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
            <SeminartermineBreadcrumb seminarId={createProps.seminarId} />,
            <TerminBreadcrumb
                seminarId={createProps.seminarId}
                terminId={createProps.terminId}
            />,
            <TermintexteBreadcrumb
                seminarId={createProps.seminarId}
                terminId={createProps.terminId}
            />
        ],
    },
    ...createTeilnahmenRouterDefinitions(
        TERMINPATH,
        (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
            <SeminartermineBreadcrumb seminarId={createProps.seminarId} />,
            <TerminBreadcrumb
                seminarId={createProps.seminarId}
                terminId={createProps.terminId}
            />,
        ],
        (createProps: any) => ([
            { context: "seminar", contextId: createProps.seminarId },
            { context: "termin", contextId: createProps.terminId }
        ])),
    {
        exact: true,
        path: `${TERMINPATH}/belegungen`,
        parentPath: TERMINPATH,
        render: (renderProps: any) => <SeminarBelegungenView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
            <SeminartermineBreadcrumb seminarId={createProps.seminarId} />,
            <TerminBreadcrumb
                seminarId={createProps.seminarId}
                terminId={createProps.terminId}
            />,
            <BelegungenBreadcrumb />
        ],
    },
    {
        exact: true,
        path: TERMINPATH,
        parentPath: TERMINPATH,
        render: (renderProps: any) => <TerminDetailsView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
            <SeminartermineBreadcrumb seminarId={createProps.seminarId} />,
            <TerminBreadcrumb
                seminarId={createProps.seminarId}
                terminId={createProps.terminId}
            />,
        ],
    },
    {
        path: SEMINARDOZIERENDPATH,
        render: (renderProps: any) => (
            <VerticalSplit
                right={() => <SeminarDozierendView {...renderProps} />}
                left={() => <SeminarDozierendeNavigationView {...renderProps} />}
            />
        ),
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
            <SeminarDozierendeBreadcrumb seminarId={createProps.seminarId} />,
            <SeminarDozierendBreadcrumb
                seminarId={createProps.seminarId}
                seminarDozierendId={createProps.seminarDozierendId}
            />,
        ],
    },
    {
        exact: true,
        path: SEMINARDOZIERENDPATH,
        parentPath: SEMINARDOZIERENDPATH,
        render: (renderProps: any) => <SeminarDozierendDetailsView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
            <SeminarDozierendeBreadcrumb seminarId={createProps.seminarId} />,
            <SeminarDozierendBreadcrumb
                seminarId={createProps.seminarId}
                seminarDozierendId={createProps.dozierendId}
            />,
        ],
    },
    ...createBelegeRouterDefinitions(SEMINARPATH, (createProps) => [
        <SeminareBreadcrumb />,
        <SeminarBreadcrumb seminarId={createProps.seminarId} />,
    ]),
    {
        path: SEMINARPATH,
        render: (renderProps: any) => (
            <VerticalSplit
                right={() => <SeminarView {...renderProps} />}
                left={() => <SeminareNavigationView {...renderProps} />}
            />
        ),
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
        ],
    },
    {
        exact: true,
        path: SEMINARPATH,
        parentPath: SEMINARPATH,
        render: (renderProps: any) => <SeminarDetailsView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
        ],
    },
    {
        exact: true,
        path: "/seminar/:seminarId/texte",
        parentPath: SEMINARPATH,
        render: (renderProps: any) => <SeminartexteView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
            <SeminartexteBreadcrumb seminarId={createProps.seminarId} />,
        ],
    },
    {
        exact: true,
        path: "/seminar/:seminarId/ort",
        parentPath: SEMINARPATH,
        render: renderProps => <SeminarVeranstaltungsortView {...renderProps} />,
        createBreadcrumbs: createProps => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
            <SeminarVeranstaltungsortBreadcrumb seminarId={createProps.seminarId} />,
        ],
    },
    {
        exact: true,
        path: "/seminar/:seminarId/eMailEinstellungen",
        parentPath: SEMINARPATH,
        render: (renderProps: any) => <SeminarEMailEinstellungenView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
            <SeminarEMailEinstellungenBreadcrumb seminarId={createProps.seminarId} />,
        ],
    },
    {
        exact: true,
        path: "/seminar/:seminarId/stornobedingungen",
        parentPath: SEMINARPATH,
        render: (renderProps: any) => <StornobedingungDefinitionZuteilungView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
            <StornobedingungenBreadcrumb {...createProps} seminarId={createProps.seminarId} seminarreiheId={createProps.seminarreiheId} />
        ],
    },
    {
        exact: true,
        path: "/seminar/:seminarId/dozierende",
        parentPath: SEMINARPATH,
        render: (renderProps: any) => <SeminarDozierendeView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
            <SeminarDozierendeBreadcrumb seminarId={createProps.seminarId} />,
        ],
    },
    {
        exact: true,
        path: "/seminar/:seminarId/termine",
        parentPath: SEMINARPATH,
        render: (renderProps: any) => <TermineView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
            <SeminartermineBreadcrumb seminarId={createProps.seminarId} />,
        ],
    },
    {
        exact: true,
        path: "/seminar/:seminarId/reihen",
        parentPath: SEMINARPATH,
        render: (renderProps: any) => <SeminarSeminarreihenView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
            <SeminarSeminarreihenZuSeminarBreadcrumb seminarId={createProps.seminarId} />,
        ],
    },
    {
        exact: true,
        path: "/seminar/:seminarId/anwesenheitsliste",
        parentPath: SEMINARPATH,
        render: (renderProps: any) => <SeminarAnwesenheitslisteView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
            <SeminarAnwesenheitslisteBreadcrumb seminarId={createProps.seminarId} />,
        ],
    },
    {
        exact: true,
        path: "/seminar/:seminarId/regelliste",
        parentPath: SEMINARPATH,
        render: (props: any) => <RegellisteView {...props} />,
        createBreadcrumbs: (props: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb {...props} />,
            <RegellisteBreadcrumb {...props} />
        ],
    },
    {
        path: "/seminar/:seminarId/regelliste/regel/:regelId",
        render: (props: any) => (
            <VerticalSplit
                left={() => <RegellisteNavigationView {...props} />}
                right={() => <RegelView {...props} />}
            />
        ),
        createBreadcrumbs: (props: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb {...props} />,
            <RegellisteBreadcrumb {...props} />,
            <RegelBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        path: "/seminar/:seminarId/regelliste/regel/:regelId",
        parentPath: "/seminar/:seminarId/regelliste/regel/:regelId",
        render: (props: any) => <RegelDetailsView {...props} />,
        createBreadcrumbs: (props: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb {...props} />,
            <RegellisteBreadcrumb {...props} />,
            <RegelBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        path: "/seminar/:seminarId/ticket",
        parentPath: SEMINARPATH,
        render: (renderProps: any) => <SeminarTicketView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
            <SeminarTicketBreadcrumb seminarId={createProps.seminarId} />,
        ],
    },
    {
        exact: true,
        path: "/seminar/:seminarId/teams",
        parentPath: SEMINARPATH,
        render: (props) => <SeminarTeamsEinstellungenView {...props} />,
        createBreadcrumbs: (props) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb {...props} />,
            <SeminarTeamsEinstellungenBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        path: "/seminar/:seminarId/zoom",
        parentPath: SEMINARPATH,
        render: (props) => <SeminarZoomEinstellungenView {...props} />,
        createBreadcrumbs: (props) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb {...props} />,
            <SeminarZoomEinstellungenBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        path: "/seminar/:seminarId/bilder",
        parentPath: SEMINARPATH,
        render: (renderProps: any) => <SeminarbilderView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
            <SeminarbilderBreadcrumb seminarId={createProps.seminarId} />,
        ],
    },
    {
        exact: true,
        path: "/seminar/:seminarId/dateien",
        parentPath: SEMINARPATH,
        render: (renderProps: any) => <SeminardateienView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
            <SeminardateienBreadcrumb seminarId={createProps.seminarId} />,
        ],
    },
    {
        exact: true,
        path: "/seminar/:seminarId/rechnungsdaten",
        parentPath: SEMINARPATH,
        render: (renderProps: any) => <SeminarRechnungsdatenView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
            <SeminarRechnungsdatenBreadcrumb seminarId={createProps.seminarId} />,
        ],
    },
    {
        exact: true,
        path: "/seminar/:seminarId/gruppe",
        parentPath: SEMINARPATH,
        render: (renderProps: any) => <SeminarGruppeView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
            <SeminarGruppeBreadcrumb seminarId={createProps.seminarId} />,
        ],
    },
    {
        path: DOZIERENDEPATH,
        render: (props) => <DozierendeView />,
        createBreadcrumbs: (props) => [<DozierendeBreadcrumb />]
    },
    {
        path: DOZIERENDPATH,
        render: (props) => <VerticalSplit
            left={() => <DozierendeNavigationView {...props} />}
            right={() => <DozierendView {...props} />}
        />,
        createBreadcrumbs: (props) => [
            <DozierendeBreadcrumb />,
            <DozierendBreadcrumb {...props} />
        ],
    },
    {
        exact: true,
        parentPath: DOZIERENDPATH,
        path: DOZIERENDPATH,
        render: (props) => <DozierendDetailsView {...props} />,
        createBreadcrumbs: (props) => [
            <DozierendeBreadcrumb />,
            <DozierendBreadcrumb {...props} />
        ],
    },
    {
        exact: true,
        parentPath: DOZIERENDPATH,
        path: DOZIERENDDATEIENPATH,
        render: (renderProps: any) => <DozierenddateienView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <DozierendeBreadcrumb />,
            <DozierendBreadcrumb dozierendId={createProps.dozierendId} />,
            <DozierenddateienBreadcrumb dozierendId={createProps.dozierendId} />,
        ],
    },
    {
        path: DOZIERENDDATEIPATH,
        render: (renderProps: any) => (
            <VerticalSplit
                right={() => <DozierenddateiView {...renderProps} />}
                left={() => <DozierenddateienNavigationView {...renderProps} />}
            />
        ),
        createBreadcrumbs: (createProps: any) => [
            <DozierendeBreadcrumb />,
            <DozierendBreadcrumb dozierendId={createProps.dozierendId} />,
            <DozierenddateienBreadcrumb dozierendId={createProps.dozierendId} />,
            <DozierenddateiBreadcrumb
                dozierendId={createProps.dozierendId}
                dozierenddateiId={createProps.dozierenddateiId}
            />,
        ],
    },
    {
        exact: true,
        path: DOZIERENDDATEIPATH,
        parentPath: DOZIERENDDATEIPATH,
        render: (renderProps: any) => <DozierenddateiDetailsView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <DozierendeBreadcrumb />,
            <DozierendBreadcrumb dozierendId={createProps.dozierendId} />,
            <DozierenddateienBreadcrumb dozierendId={createProps.dozierendId} />,
            <DozierenddateiBreadcrumb
                dozierendId={createProps.dozierendId}
                dozierenddateiId={createProps.dozierenddateiId}
            />,
        ],
    },
    {
        exact: true,
        parentPath: DOZIERENDPATH,
        path: `${DOZIERENDPATH}/texte`,
        render: (props) => <DozierendtexteView {...props} />,
        createBreadcrumbs: (props) => [
            <DozierendeBreadcrumb />,
            <DozierendBreadcrumb {...props} />,
            <DozierendtexteBreadcrumb {...props} />
        ],
    },
    {
        exact: true,
        parentPath: DOZIERENDPATH,
        path: `${DOZIERENDPATH}/seminare`,
        render: (props) => <SeminareView {...props} />,
        createBreadcrumbs: (props) => [
            <DozierendeBreadcrumb />,
            <DozierendBreadcrumb {...props} />,
            <DozierendSeminareBreadcrumb {...props} />
        ],
    },
    {
        exact: true,
        parentPath: DOZIERENDPATH,
        path: `${DOZIERENDPATH}/bilder`,
        render: (props) => <DozierendbilderView {...props} />,
        createBreadcrumbs: (props) => [
            <DozierendeBreadcrumb />,
            <DozierendBreadcrumb {...props} />,
            <DozierendbilderBreadcrumb {...props} />
        ],
    },
    {
        exact: true,
        path: DOZIERENDBILDPATH,
        render: (renderProps: any) => (
            <VerticalSplit
                right={() => <DozierendbildView {...renderProps} />}
                left={() => <DozierendbilderNavigationView {...renderProps} />}
            />
        ),
        createBreadcrumbs: (createProps: any) => [
            <DozierendeBreadcrumb />,
            <DozierendBreadcrumb dozierendId={createProps.dozierendId} />,
            <DozierendbilderBreadcrumb dozierendId={createProps.dozierendId} />,
            <DozierendbildBreadcrumb
                dozierendId={createProps.dozierendId}
                dozierendbildId={createProps.dozierendbildId}
            />,
        ],
    },
    {
        exact: true,
        path: DOZIERENDBILDPATH,
        parentPath: DOZIERENDBILDPATH,
        render: (renderProps: any) => <DozierendbildDetailsView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <DozierendeBreadcrumb />,
            <DozierendBreadcrumb dozierendId={createProps.dozierendId} />,
            <DozierendbilderBreadcrumb dozierendId={createProps.dozierendId} />,
            <DozierendbildBreadcrumb
                dozierendId={createProps.dozierendId}
                dozierendbildId={createProps.dozierendbildId}
            />,
        ],
    },
    {
        path: TERMINBELEGUNGPATH,
        render: (props) => <VerticalSplit
            left={() => <BelegungenNavigationView {...props} />}
            right={() => <BelegungView {...props} />}
        />,
        createBreadcrumbs: (props) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={props.seminarId} />,
            <SeminartermineBreadcrumb seminarId={props.seminarId} />,
            <TerminBreadcrumb
                seminarId={props.seminarId}
                terminId={props.terminId}
            />,
            <BelegungenBreadcrumb {...props} />,
            <BelegungBreadcrumb {...props} />
        ],
    },
    {
        exact: true,
        parentPath: TERMINBELEGUNGPATH,
        path: TERMINBELEGUNGPATH,
        render: (props) => <BelegungDetailsView {...props} />,
        createBreadcrumbs: (props) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={props.seminarId} />,
            <SeminartermineBreadcrumb seminarId={props.seminarId} />,
            <TerminBreadcrumb
                seminarId={props.seminarId}
                terminId={props.terminId}
            />,
            <BelegungenBreadcrumb {...props} />,
            <BelegungBreadcrumb {...props} />
        ],
    },
    ...createBelegungenRouterDefinitions(
        SEMINARPATH,
        props => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={props.seminarId} />,
        ]
    ),
    {
        exact: true,
        path: `${SEMINARPATH}/belegungen-seminar`,
        parentPath: SEMINARPATH,
        render: (renderProps: any) => <SeminarBelegungenView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={createProps.seminarId} />,
            <BelegungenBreadcrumb />
        ],
    },
    {
        path: SEMINARBELEGUNGPATH,
        render: (props) => <VerticalSplit
            left={() => <BelegungenNavigationView {...props} />}
            right={() => <BelegungView {...props} />}
        />,
        createBreadcrumbs: (props) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={props.seminarId} />,
            <BelegungenBreadcrumb {...props} />,
            <BelegungBreadcrumb {...props} />
        ],
    },
    {
        exact: true,
        parentPath: SEMINARBELEGUNGPATH,
        path: SEMINARBELEGUNGPATH,
        render: (props) => <BelegungDetailsView {...props} />,
        createBreadcrumbs: (props) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={props.seminarId} />,
            <BelegungenBreadcrumb {...props} />,
            <BelegungBreadcrumb {...props} />
        ],
    },
    {
        path: "/frageboegen",
        render: props => <FrageboegenView {...props} />,
        createBreadcrumbs: () => [<FrageboegenBreadcrumb />],
    },
    {
        path: "/fragebogen/:fragebogenId",
        render: props => (
            <VerticalSplit
                left={() => <FrageboegenNavigationView {...props} />}
                right={() => <FragebogenView {...props} />}
            />
        ),
        createBreadcrumbs: props => [
            <FrageboegenBreadcrumb />,
            <FragebogenBreadcrumb {...props} />
        ],
    },
    {
        exact: true,
        parentPath: "/fragebogen/:fragebogenId",
        path: "/fragebogen/:fragebogenId",
        render: props => <FragebogenDetailsView {...props} />,
        createBreadcrumbs: props => [
            <FrageboegenBreadcrumb />,
            <FragebogenBreadcrumb {...props} />
        ],
    },
    {
        exact: true,
        parentPath: "/fragebogen/:fragebogenId",
        path: "/fragebogen/:fragebogenId/fragen",
        render: props => <FragebogenFragenView {...props} />,
        createBreadcrumbs: props => [
            <FrageboegenBreadcrumb />,
            <FragebogenBreadcrumb {...props} />,
            <FragebogenFragenBreadcrumb {...props} />
        ],
    },
    {
        path: "/fragebogen/:fragebogenId/frage/:frageId",
        render: props => (
            <VerticalSplit
                left={() => <FragebogenFragenNavigationView {...props} />}
                right={() => <FragebogenFrageView {...props} />}
            />
        ),
        createBreadcrumbs: props => [
            <FrageboegenBreadcrumb />,
            <FragebogenBreadcrumb {...props} />,
            <FragebogenFragenBreadcrumb {...props} />,
            <FragebogenFrageBreadcrumb {...props} />
        ],
    },
    {
        exact: true,
        parentPath: "/fragebogen/:fragebogenId/frage/:frageId",
        path: "/fragebogen/:fragebogenId/frage/:frageId",
        render: props => <FragebogenFrageDetailsView {...props} />,
        createBreadcrumbs: props => [
            <FrageboegenBreadcrumb />,
            <FragebogenBreadcrumb {...props} />,
            <FragebogenFragenBreadcrumb {...props} />,
            <FragebogenFrageBreadcrumb {...props} />
        ],
    },
    {
        exact: true,
        parentPath: "/seminar/:seminarId",
        path: "/seminar/:seminarId/evaluation",
        render: props => <SeminarevaluationView {...props} />,
        createBreadcrumbs: props => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb {...props} />,
            <SeminarevaluationBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        path: KOOPERATIONSPARTNERPATH,
        render: props => <KooperationspartnerView />,
        createBreadcrumbs: props => [
            <KooperationspartnerBreadcrumb />
        ]
    },
    {
        path: `${KOOPERATIONSPARTNERPATH}/:kooperationspartnerId`,
        render: props => <VerticalSplit
            left={() => <KooperationspartnerNavigationView {...props} />}
            right={() => <KooperationspartnerTabsView {...props} />}
        />,
        createBreadcrumbs: props => [
            <KooperationspartnerBreadcrumb />,
            <KooperationspartnerDetailsBreadcrumb {...props} />,
        ]
    },
    {
        exact: true,
        path: `${KOOPERATIONSPARTNERPATH}/:kooperationspartnerId`,
        parentPath: `${KOOPERATIONSPARTNERPATH}/:kooperationspartnerId`,
        render: props => <KooperationspartnerDetailsView {...props} />,
        createBreadcrumbs: props => [
            <KooperationspartnerBreadcrumb />
        ],
    },
    {
        exact: true,
        path: `${SEMINARPATH}/kooperation`,
        parentPath: SEMINARPATH,
        render: props => <SeminarKooperationView {...props} />,
        createBreadcrumbs: props => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb {...props} />,
            <SeminarKooperationBreadcrumb {...props} />,
        ]
    },
    {
        exact: true,
        path: `${SEMINARPATH}/zusatzfelder`,
        parentPath: SEMINARPATH,
        render: props => <SeminarZusatzfelderView {...props} />,
        createBreadcrumbs: props => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb {...props} />,
            <SeminarZusatzfelderBreadcrumb {...props} />,
        ]
    },
    {
        path: `/seminar/:seminarId/seminarzertifikat/:seminarZertifikatId`,
        render: (renderProps: any) => (
            <VerticalSplit
                right={() => <SeminarZertifikatView {...renderProps} />}
                left={() => <SeminarZertifikateNavigationView {...renderProps} />}
            />
        ),
        createBreadcrumbs: (props: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={props.seminarId} />,
            <SeminarZertifikateBreadcrumb {...props} />,
            <SeminarZertifikatBreadcrumb {...props} />
        ],
    },
    {
        exact: true,
        path: `/seminar/:seminarId/seminarzertifikat/:seminarZertifikatId`,
        parentPath: `/seminar/:seminarId/seminarzertifikat/:seminarZertifikatId`,
        render: (renderProps: any) => <SeminarZertifikatDetailsView {...renderProps} />,
        createBreadcrumbs: (props: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={props.seminarId} />,
            <SeminarZertifikateBreadcrumb {...props} />,
            <SeminarZertifikatBreadcrumb {...props} />
        ],
    },
    {
        exact: true,
        path: `/seminar/:seminarId/seminarzertifikat/:seminarZertifikatId/teilnahmen`,
        parentPath: `/seminar/:seminarId/seminarzertifikat/:seminarZertifikatId`,
        render: (renderProps: any) => <SeminarZertifikatTeilnahmenView {...renderProps} />,
        createBreadcrumbs: (props: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb seminarId={props.seminarId} />,
            <SeminarZertifikateBreadcrumb {...props} />,
            <SeminarZertifikatBreadcrumb {...props} />,
            <SeminarZertifikatTeilnahmenBreadcrumb {...props} />
        ],
    },
    {
        exact: true,
        path: `${SEMINARPATH}/seminarzertifikate`,
        parentPath: SEMINARPATH,
        render: props => <SeminarZertifikateView {...props} />,
        createBreadcrumbs: props => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb {...props} />,
            <SeminarZertifikateBreadcrumb {...props} />,
        ]
    },
    {
        exact: true,
        path: `${SEMINARPATH}/verpflegung`,
        parentPath: SEMINARPATH,
        render: props => <SeminarVerpflegungsartenView {...props} />,
        createBreadcrumbs: props => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb {...props} />,
            <SeminarverpflegungBreadcrumb {...props} />,
        ]
    },
    {
        exact: true,
        path: `${SEMINARPATH}/gebuchteVerpflegungen`,
        parentPath: SEMINARPATH,
        render: props => <GebuchteVerpflegungenView {...props} />,
        createBreadcrumbs: props => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb {...props} />,
        ]
    },
    /* Seminarreihen */
    {
        path: "/seminarreihen",
        render: props => <SeminarreihenView {...props} />,
        createBreadcrumbs: props => [
            <SeminarreihenBreadcrumb {...props} />,
        ],
    },
    {
        path: SEMINARREIHEPATH,
        render: props => (
            <VerticalSplit
                left={() => <SeminarreihenNavigationView {...props} />}
                right={() => <SeminarreiheView {...props} />}
            />
        ),
        createBreadcrumbs: props => [
            <SeminarreihenBreadcrumb {...props} />,
            <SeminarreiheBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        parentPath: SEMINARREIHEPATH,
        path: SEMINARREIHEPATH,
        render: props => <SeminarreiheDetailsView {...props} />,
        createBreadcrumbs: props => [
            <SeminarreihenBreadcrumb {...props} />,
            <SeminarreiheBreadcrumb {...props} />,
        ],
    },
    {
        parentPath: SEMINARREIHEPATH,
        path: `${SEMINARREIHEPATH}/texte`,
        render: props => <SeminarreihetexteView {...props} />,
        createBreadcrumbs: props => [
            <SeminarreihenBreadcrumb {...props} />,
            <SeminarreiheBreadcrumb {...props} />,
            <SeminarreihetexteBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        parentPath: SEMINARREIHEPATH,
        path: `${SEMINARREIHEPATH}/regelliste`,
        render: props => <RegellisteView {...props} />,
        createBreadcrumbs: props => [
            <SeminarreihenBreadcrumb {...props} />,
            <SeminarreiheBreadcrumb {...props} />,
            <RegellisteBreadcrumb {...props} />,
        ],
    },
    {
        path: `${SEMINARREIHEPATH}/regelliste/regel/:regelId`,
        render: (props: any) => (
            <VerticalSplit
                left={() => <RegellisteNavigationView {...props} />}
                right={() => <RegelView {...props} />}
            />
        ),
        createBreadcrumbs: (props: any) => [
            <SeminarreihenBreadcrumb />,
            <SeminarreiheBreadcrumb {...props} />,
            <RegellisteBreadcrumb {...props} />,
            <RegelBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        path: `${SEMINARREIHEPATH}/regelliste/regel/:regelId`,
        parentPath: `${SEMINARREIHEPATH}/regelliste/regel/:regelId`,
        render: (props: any) => <RegelDetailsView {...props} />,
        createBreadcrumbs: (props: any) => [
            <SeminarreihenBreadcrumb />,
            <SeminarreiheBreadcrumb {...props} />,
            <RegellisteBreadcrumb {...props} />,
            <RegelBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        path: `${SEMINARREIHEPATH}/zusatzfelder`,
        parentPath: SEMINARREIHEPATH,
        render: props => <SeminarreiheZusatzfelderView {...props} />,
        createBreadcrumbs: props => [
            <SeminarreihenBreadcrumb />,
            <SeminarreiheBreadcrumb {...props} />,
            <SeminarreiheZusatzfelderBreadcrumb {...props} />,
        ]
    },
    {
        parentPath: SEMINARREIHEPATH,
        path: `${SEMINARREIHEPATH}/seminare`,
        render: props => <SeminarreiheSeminareView {...props} />,
        createBreadcrumbs: props => [
            <SeminarreihenBreadcrumb {...props} />,
            <SeminarreiheBreadcrumb {...props} />,
            <SeminarreiheSeminareBreadcrumb {...props} />,
        ],
    },
    {
        path: SEMINARREIHESEMINARPATH,
        render: props => (
            <VerticalSplit
                left={() => <SeminarreiheSeminareNavigationView {...props} />}
                right={() => <SeminarreiheSeminarView {...props} />}
            />
        ),
        createBreadcrumbs: props => [
            <SeminarreihenBreadcrumb {...props} />,
            <SeminarreiheBreadcrumb {...props} />,
            <SeminarreiheSeminareBreadcrumb {...props} />,
            <SeminarreiheSeminarBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        parentPath: SEMINARREIHESEMINARPATH,
        path: SEMINARREIHESEMINARPATH,
        render: props => <SeminarreiheSeminarDetailsView {...props} />,
        createBreadcrumbs: props => [
            <SeminarreihenBreadcrumb {...props} />,
            <SeminarreiheBreadcrumb {...props} />,
            <SeminarreiheSeminareBreadcrumb {...props} />,
            <SeminarreiheSeminarBreadcrumb {...props} />,
        ],
    },
    {
        parentPath: SEMINARREIHEPATH,
        path: `${SEMINARREIHEPATH}/bilder`,
        render: props => <SeminarreihebilderView {...props} />,
        createBreadcrumbs: props => [
            <SeminarreihenBreadcrumb {...props} />,
            <SeminarreiheBreadcrumb {...props} />,
            <SeminarreihebilderBreadcrumb {...props} />,
        ],
    },
    {
        path: SEMINARREIHEBILDPATH,
        render: props => (
            <VerticalSplit
                left={() => <SeminarreihebilderNavigationView {...props} />}
                right={() => <SeminarreihebildView {...props} />}
            />
        ),
        createBreadcrumbs: props => [
            <SeminarreihenBreadcrumb {...props} />,
            <SeminarreiheBreadcrumb {...props} />,
            <SeminarreihebilderBreadcrumb {...props} />,
            <SeminarreihebildBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        parentPath: SEMINARREIHEBILDPATH,
        path: SEMINARREIHEBILDPATH,
        render: props => <SeminarreihebildDetailsView {...props} />,
        createBreadcrumbs: props => [
            <SeminarreihenBreadcrumb {...props} />,
            <SeminarreiheBreadcrumb {...props} />,
            <SeminarreihebilderBreadcrumb {...props} />,
            <SeminarreihebildBreadcrumb {...props} />,
        ],
    },
    {
        parentPath: SEMINARREIHEPATH,
        path: `${SEMINARREIHEPATH}/dateien`,
        render: props => <SeminarreihedateienView {...props} />,
        createBreadcrumbs: props => [
            <SeminarreihenBreadcrumb {...props} />,
            <SeminarreiheBreadcrumb {...props} />,
            <SeminarreihedateienBreadcrumb {...props} />,
        ],
    },
    {
        path: SEMINARREIHEDATEIPATH,
        render: props => (
            <VerticalSplit
                left={() => <SeminarreihedateienNavigationView {...props} />}
                right={() => <SeminarreihedateiView {...props} />}
            />
        ),
        createBreadcrumbs: props => [
            <SeminarreihenBreadcrumb {...props} />,
            <SeminarreiheBreadcrumb {...props} />,
            <SeminarreihedateienBreadcrumb {...props} />,
            <SeminarreihedateiBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        parentPath: SEMINARREIHEDATEIPATH,
        path: SEMINARREIHEDATEIPATH,
        render: props => <SeminarreihedateiDetailsView {...props} />,
        createBreadcrumbs: props => [
            <SeminarreihenBreadcrumb {...props} />,
            <SeminarreiheBreadcrumb {...props} />,
            <SeminarreihedateienBreadcrumb {...props} />,
            <SeminarreihedateiBreadcrumb {...props} />,
        ],
    },
    {
        parentPath: SEMINARREIHEPATH,
        path: `${SEMINARREIHEPATH}/paketpreise`,
        render: props => <PaketpreiseView {...props} />,
        createBreadcrumbs: props => [
            <SeminarreihenBreadcrumb {...props} />,
            <SeminarreiheBreadcrumb {...props} />,
            <PaketpreiseBreadcrumb {...props} />,
        ],
    },
    {
        path: PAKETPREISPATH,
        render: props => (
            <VerticalSplit
                left={() => <PaketpreiseNavigationView {...props} />}
                right={() => <PaketpreisView {...props} />}
            />
        ),
        createBreadcrumbs: props => [
            <SeminarreihenBreadcrumb {...props} />,
            <SeminarreiheBreadcrumb {...props} />,
            <PaketpreiseBreadcrumb {...props} />,
            <PaketpreisBreadcrumb {...props} />,
        ],
    },
    {
        parentPath: PAKETPREISPATH,
        path: PAKETPREISPATH,
        render: props => <PaketpreisDetailsView {...props} />,
        createBreadcrumbs: props => [
            <SeminarreihenBreadcrumb {...props} />,
            <SeminarreiheBreadcrumb {...props} />,
            <PaketpreiseBreadcrumb {...props} />,
            <PaketpreisBreadcrumb {...props} />,
        ],
    },
    {
        path: SEMINAREINSTELLUNGENPATH,
        render: props => <SeminarGrundeinstellungenView {...props} />,
        createBreadcrumbs: props => [<SeminarGrundeinstellungenBreadcrumb />]
    },
    {
        path: SEMINAREINSTELLUNGENPATH,
        parentPath: SEMINAREINSTELLUNGENPATH,
        render: props => <SeminarGrundeinstellungenDetailsView {...props} />,
        createBreadcrumbs: props => [<SeminarGrundeinstellungenBreadcrumb />]
    },
    {
        path: `${SEMINAREINSTELLUNGENPATH}/eMail`,
        parentPath: SEMINAREINSTELLUNGENPATH,
        render: props => <SeminarGrundeinstellungenEMailView {...props} />,
        createBreadcrumbs: props => [<SeminarGrundeinstellungenBreadcrumb />, <SeminarGrundeinstellungenEMailBreadcrumb />]
    },
    {
        path: `${SEMINAREINSTELLUNGENPATH}/ticket`,
        parentPath: SEMINAREINSTELLUNGENPATH,
        render: props => <SeminarGrundeinstellungenTicketView {...props} />,
        createBreadcrumbs: props => [<SeminarGrundeinstellungenBreadcrumb />, <SeminarGrundeinstellungenTicketBreadcrumb />]
    },
    {
        path: ARTIKELEINSTELLUNGENPATH,
        render: props => <ArtikelGrundeinstellungenView {...props} />,
        createBreadcrumbs: props => [<ArtikelGrundeinstellungenBreadcrumb />]
    },
    {
        path: ARTIKELEINSTELLUNGENPATH,
        parentPath: ARTIKELEINSTELLUNGENPATH,
        render: props => <ArtikelGrundeinstellungenDetailsView {...props} />,
        createBreadcrumbs: props => [<ArtikelGrundeinstellungenBreadcrumb />]
    },
    {
        path: `${SEMINARDOZIERENDPATH}/zertifikat/:seminarDozierendZertifikatId`,
        render: (renderProps: any) => (
            <VerticalSplit
                right={() => <SeminarDozierendZertifikatView {...renderProps} />}
                left={() => <SeminarDozierendZertifikateNavigationView {...renderProps} />}
            />
        ),
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb {...createProps} />,
            <SeminarDozierendeBreadcrumb {...createProps} />,
            <SeminarDozierendBreadcrumb {...createProps} />,
            <SeminarDozierendZertifikateBreadcrumb {...createProps} />,
            <SeminarDozierendZertifikatBreadcrumb {...createProps} />,
        ],
    },
    {
        exact: true,
        path: `${SEMINARDOZIERENDPATH}/zertifikat/:seminarDozierendZertifikatId`,
        parentPath: `${SEMINARDOZIERENDPATH}/zertifikat/:seminarDozierendZertifikatId`,
        render: (renderProps: any) => <SeminarDozierendZertifikatDetailsView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb {...createProps} />,
            <SeminarDozierendeBreadcrumb {...createProps} />,
            <SeminarDozierendBreadcrumb {...createProps} />,
            <SeminarDozierendZertifikateBreadcrumb {...createProps} />,
            <SeminarDozierendZertifikatBreadcrumb {...createProps} />,
        ],
    },
    {
        exact: true,
        path: `${SEMINARDOZIERENDPATH}/zertifikate`,
        parentPath: SEMINARDOZIERENDPATH,
        render: (renderProps: any) => <SeminarDozierendZertifikateView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <SeminareBreadcrumb />,
            <SeminarBreadcrumb {...createProps} />,
            <SeminarDozierendeBreadcrumb {...createProps} />,
            <SeminarDozierendBreadcrumb {...createProps} />,
            <SeminarDozierendZertifikateBreadcrumb {...createProps} />,
        ],
    },
    {
        exact: true,
        path: `${DOZIERENDPATH}/zusatzfelder`,
        parentPath: DOZIERENDPATH,
        render: props => <DozierendZusatzfelderView {...props} />,
        createBreadcrumbs: props => [
            <DozierendeBreadcrumb />,
            <DozierendBreadcrumb {...props} />,
            <DozierendZusatzfelderBreadcrumb {...props} />,
        ]
    },
    ...createBestellungenRouterDefinitions(
        SEMINARPATH,
        (props) => [<SeminareBreadcrumb />, <SeminarBreadcrumb {...props} />],),
    ...createPreiseRouterDefinitions(
        SEMINARPATH,
        (props) => [<SeminareBreadcrumb />, <SeminarBreadcrumb {...props} />],),
    ...createRabattcodesRouterDefinitions(
        SEMINARPATH,
        (props) => [<SeminareBreadcrumb />, <SeminarBreadcrumb {...props} />],),
    ...createArtikelRouterDefinitions(
        undefined,
        (props) => []),
    ...createArtikelRouterDefinitions(
        SEMINARPATH,
        (props) => [<SeminareBreadcrumb />, <SeminarBreadcrumb {...props} />]),
    ...createBestellterArtikelRouterDefinitions(
        SEMINARPATH,
        (props) => [<SeminareBreadcrumb />, <SeminarBreadcrumb {...props} />]),
    ...createArtikelRouterDefinitions(
        SEMINARREIHEPATH,
        (props) => [<SeminarreihenBreadcrumb />, <SeminarreiheBreadcrumb {...props} />]),
    ...createBestellterArtikelRouterDefinitions(
        SEMINARREIHEPATH,
        (props) => [<SeminarreihenBreadcrumb />, <SeminarreiheBreadcrumb {...props} />]),
];